import {
  CLEAR_BUYER_CONTACT_LIST_ERROR,
  GET_BUYER_CONTACT_LIST_REQUESTED,
} from './actionTypes';

export const getBuyerContactList = (contactSearchCriteria) => ({
  type: GET_BUYER_CONTACT_LIST_REQUESTED,
  payload: {
    contactSearchCriteria,
  },
});

export const clearBuyerContactListError = () => ({
  type: CLEAR_BUYER_CONTACT_LIST_ERROR,
});
